import { CommercialDetails } from "~/domains/product/components/CommercialDetails";
import { shouldRenderMMDTag } from "~/domains/product/components/MMDChip";
import { shouldRenderReconditionableTag } from "~/domains/product/components/ReconditionableTag";
import { Product } from "~/domains/product/Product";

import ProductDesignation from "../../ProductDesignation";
import { PredefinedTraits } from "../../ProductTrait";
import { Stack } from "~/common/mui";
import { useProductDescriptorContext } from "~/domains/product/ProductContext";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import type { PdpPageProductData } from "~/features/productDetails/models/PdpPageProductData";
import { getIsContractAvailable } from "~/features/productDetails/redux/productDetailsSelectors";

import { NewVersionMessage } from "~/common/components/Messages/NewVersionMessage";
import {
  isProductComparisonCheckboxVisible,
  ProductComparisonCheckbox,
} from "~/features/compareProducts/components/ProductComparisonCheckbox";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";

export const ProductDetailsSection = () => {
  const productDescriptor = useProductDescriptorContext() as ProductDescriptor<PdpPageProductData>;
  const product = productDescriptor.base;

  const showTagRow = shouldRenderMMDTag(product) || shouldRenderReconditionableTag(productDescriptor);

  const isContractProduct = getIsContractAvailable(productDescriptor);

  const isDesktop = useIsMinDesktopSize();

  return (
    <Stack gap={2}>
      <Stack gap={1}>
        <ProductDesignation
          as={"h1"}
          designation={product.designation}
          size={"headline-medium"}
          isPreferred={product.preferred}
          showCopyClipboard
        />
        {showTagRow && (
          <Stack gap={1} direction={"row"}>
            <Product.MMDTag />
            <Product.ReconditionableTag />
          </Stack>
        )}
      </Stack>

      <Stack gap={1}>
        <Product.ShortDescriptionV2 component={"h2"} variant="bodyLarge" data-test-id={"pdp-short-description"} />
        <Product.DescriptionV2 component={"h3"} color="text.secondary" data-test-id={"pdp-long-description"} />
      </Stack>

      {isProductComparisonCheckboxVisible(productDescriptor.base) && (
        <ProductComparisonCheckbox productCode={product.code} gaLocation={"Product Detail Page"} />
      )}

      <CommercialDetails defaultExpanded={isDesktop} />

      <NewVersionMessage baseProduct={product} />

      {isContractProduct && <PredefinedTraits.ContractProduct />}
    </Stack>
  );
};
